/// <reference path="../walkinManagerKiosk.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/short-cuts/short-cuts.interfaces.ts"/>
///<reference path="../../../components/short-cuts/models/short-cuts-group.model.ts"/>


module Meevo.Plugins.WalkinManagerKiosk.Timeout {

    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;

    class TimeoutModalController {
        static $inject = [
            '$mdDialog',
            '$timeout',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        private modalTimeout: any;
        private shortCutGroup: IShortCutGroup;

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected $timeout: ng.ITimeoutService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService
        ) {

            this.modalTimeout = $timeout(() => {
                $timeout.cancel(this.modalTimeout);
                this.$mdDialog.cancel();
            }, 15000);

            this.shortCutGroup = new ShortCutGroup([{
                shortCutName: 'MODAL_DISMISS',
                callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                    event.preventDefault();

                    this.ok();
                }
            }]);
            this.shortCutsService.activateGroup(this.shortCutGroup);
        };

        public ok (): void {
            this.$timeout.cancel(this.modalTimeout);
            this.$mdDialog.hide();
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }
    }

    angular.module('meevo.plugins.walkinManagerKiosk')
        .controller('meevo.plugins.walkinManagerKiosk.timeout.TimeoutModalController', TimeoutModalController);
}
